<template>
    <div>
        <form class="filter-group list-filter" style="display: flex; flex-wrap: wrap;">
            <filter-dropdown id="month" name="Month" :data="my_filters" :options="dropdowns.month" not-null></filter-dropdown>
            <filter-dropdown id="agency" name="Agency" :data="my_filters" :options="dropdowns.agency" multiple></filter-dropdown>
            <filter-dropdown id="billing_status" name="Status" :data="my_filters" :options="dropdowns.status" multiple></filter-dropdown>
            <filter-dropdown id="account_manager" name="Account Manager" :data="my_filters" :options="dropdowns.account_manager" multiple></filter-dropdown>
            <filter-dropdown id="salesman" name="Sales Rep" :data="my_filters" :options="dropdowns.sales_rep" multiple></filter-dropdown>
            <filter-dropdown id="billing_type" name="Billing Type" :data="my_filters" :options="dropdowns.billing_type" multiple></filter-dropdown>
            <filter-dropdown id="employer_tags" name="Tags" :data="my_filters" :options="colors" multiple></filter-dropdown>

            <div class="form-group" style="padding-top: 25px">
                <btn cssClass="btn btn-secondary" icon="fas fa-filter" :click="moreFilters"></btn>
                <btn cssClass="btn btn-secondary" icon="fas fa-redo-alt" :click="filter">Filter</btn>
            </div>
        </form>

        <dialog-filters :show="show_dialogs.filters"
                        :dropdowns="dropdowns"
                        :filter="my_filters"
                        @filter="filter"
                        @close="show_dialogs.filters = false"
        ></dialog-filters>
    </div>
</template>

<script>
import DialogFilters from "./parts/dialog-filters";

export default {
    components: {DialogFilters},
    props: [
        'filters',
        'dropdowns'
    ],
    data() {
        return {
            show_dialogs: {
                filters: false
            },
            my_filters: _.cloneDeep(this.filters),
            colors: _.values(this.dropdowns.colors),
        };
    },
    watch: {
        filters() {
            this.my_filters = _.cloneDeep(this.filters);
        }
    },
    methods: {
        filter() {
            return new Promise((resolve, reject) => {
                this.$emit('filter', this.my_filters, resolve);
            })
        },
        moreFilters() {
            this.show_dialogs.filters = true;
        },
        mergeFilters(master, defaults) {
            let results = _.cloneDeep(defaults);
            _.each(master, (val, key) => {
                results[key] = val;
            });
            return results;
        },
        getDefaultFilters() {
            // filters
            return {
                month: 'M0',
                search: '',
                billing_status: [],

                employer_id: '',
                employer: '',
                agency: [],
                campaign: '',
                account_manager: [],
                salesman: [],
                overbudget: [],

                // billing
                billable_from: '',
                billable_to: '',
                billing_type: [],
                agency_discount_from: '',
                agency_discount_to: '',
                budget_from: '',
                budget_to: '',

                mc_enabled: null,
                mc_budget_from: '',
                mc_budget_to: '',
                mc_app_goal_from: '',
                mc_app_goal_to: '',
                mc_autopacing: null,
                mc_manual_pacing: null,
                mc_daily_app_goal_from: '',
                mc_daily_app_goal_to: '',

                mc_promoted: '',
                mc_owner_operator: '',

                direct_enabled: null,
                direct_budget_from: '',
                direct_budget_to: '',
                direct_app_goal_from: '',
                direct_app_goal_to: '',

                direct_autopacing: null,
                direct_manual_pacing: null,
                direct_weekly_goal_from: '',
                direct_weekly_goal_to: '',

                direct_jobboard: null,
                direct_jobboard_promoted: null,
                calls_enabled: null,
                deja_enabled: null,

                mc_underpacing: null,
                mc_over_app_goal: null,
                mc_over_daily_goal: null,
                direct_underpacing: null,
                direct_over_app_goal: null,
                direct_over_daily_goal: null
            };
        },
    }
}
</script>
<style>
.filter-group.list-filter .form-group {
    margin-right: 10px;
    width: 160px;
}
/*.filter-group.list-filter {*/
/*    margin-left: -10px;*/
/*}*/
</style>